import React from 'react';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

export function CreationDateFormItem() {
	return (
		<S.CustomFormItem label={I18n.get('Creation date')} name="creation_date" labelCol={{ span: 24 }}>
			<S.CustomDatePicker
				format="L"
				placeholder={[I18n.get('Start date'), I18n.get('End date')]}
				disabledDate={(current) => current && current.valueOf() > Date.now()}
			/>
		</S.CustomFormItem>
	);
}
